<template>
  <aanspreking/>
</template>

<script>
import Aanspreking from '../components/OpbouwPlechtigheid/Aanspreking.vue'

export default {
  name: 'AansprekingView',
  components: {
    Aanspreking
  }
}
</script>
